/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { getImportLogDetail } from "./ImportLogsHelper";
import moment from "moment";
import { Modal } from "react-bootstrap";
import Spin from "../../common/Spin";
import { ProjectStatus } from "../../../config";
import { formatNumber } from "../../common/Misc";

const ImportLogDetail = ({
  importLogId,
  toggleShowModal,
  importLogModal,
  builderId,
}) => {
  const [importLogDetail, setImportLogDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const importLogRes = await getImportLogDetail(importLogId, builderId);
      setImportLogDetail(importLogRes);
      setLoading(false);
    }
    fetchData();
  }, [importLogId, builderId]);

  const Status = (id, description) => {
    if (id === 0 && description) {
      return `Project data not imported because ${description}`;
    } else {
      if (id === 1) {
        return "Project Created";
      } else {
        return "Project Updated";
      }
    }
  };

  const getVerifiedDateTime = (date) => {
    return moment(date).format("DD-MM-YYYY HH:mm:ss").toString();
  };

  return (
    <>
      <Modal
        size="lg"
        show={importLogModal}
        onHide={toggleShowModal}
        dialogClassName="modal-50w larg-popup review-popup small-review"
        aria-labelledby="contained-modal-title-vcenter"
        className="project-section"
        centered
      >
        <Modal.Header className="mb-0" closeButton>
          Project Details
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <Spin />
          ) : (
            <>
              <div className="modal-content">
                <h3>Details</h3>
                <div className="modal-content-details">
                  <p>
                    <strong>Project Name:</strong>{" "}
                    {importLogDetail?.project_name}
                  </p>
                  {/* <p>
                    <strong>Project Start Date:</strong>{" "}
                    {importLogDetail?.start_date
                      ? importLogDetail?.start_date
                      : "-"}
                  </p> */}
                  <p>
                    <strong>Project End Date:</strong>{" "}
                    {importLogDetail?.end_date
                      ? importLogDetail?.end_date
                      : "-"}
                  </p>
                  <p>
                    <strong>Estimated Project Cost:</strong>{" "}
                    {importLogDetail?.estimated_cost
                      ? "$" + formatNumber(importLogDetail?.estimated_cost)
                      : "$0.00"}
                  </p>
                  <p>
                    <strong>Project Status:</strong>{" "}
                    {importLogDetail?.project_status
                      ? ProjectStatus?.find(
                          (item) =>
                            item?.value ===
                            Number(importLogDetail?.project_status)
                        )?.label
                      : "-"}
                  </p>
                </div>
              </div>
              <div className="modal-content">
                <h3>Sync</h3>
                <div className="modal-content-details">
                  <p>
                    <strong>Import From:</strong>
                    {importLogDetail?.import_from
                      ? importLogDetail?.xero_tenant_name
                        ? importLogDetail?.import_from +
                          `(${importLogDetail?.xero_tenant_name})`
                        : importLogDetail?.import_from
                      : ""}
                  </p>
                  <p>
                    <strong>Import Date:</strong>
                    {importLogDetail?.created_at
                      ? moment(
                          importLogDetail?.created_at,
                          "DD-MM-YYYY HH:mm:ss"
                        ).format("DD-MM-YYYY")
                      : "-"}
                  </p>
                  <p>
                    <strong>Imported by:</strong>
                    {importLogDetail?.imported_by
                      ? importLogDetail?.imported_by?.first_name &&
                        importLogDetail?.imported_by?.last_name
                        ? importLogDetail?.imported_by?.first_name +
                          " " +
                          importLogDetail?.imported_by?.last_name
                        : importLogDetail?.imported_by?.first_name
                        ? importLogDetail?.imported_by?.first_name
                        : importLogDetail?.imported_by?.last_name
                        ? importLogDetail?.imported_by?.last_name
                        : "-"
                      : "-"}
                  </p>
                  <p>
                    <strong>Last synchronised time:</strong>{" "}
                    {importLogDetail?.last_sync_date
                      ? getVerifiedDateTime(importLogDetail?.last_sync_date)
                      : "-"}
                  </p>
                  <p>
                    <strong>Last synchronised time:</strong>{" "}
                    {importLogDetail?.project_last_sync_date
                      ? getVerifiedDateTime(
                          importLogDetail?.project_last_sync_date
                        )
                      : ""}
                  </p>
                  <p>
                    <strong>Note:</strong>
                    {importLogDetail?.status == null ||
                    importLogDetail?.status == ""
                      ? "-"
                      : Status(
                          parseInt(importLogDetail?.status),
                          importLogDetail?.description
                        )}
                  </p>
                </div>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ImportLogDetail;
